import React, { useMemo } from 'react';
import { Text } from 'react-native-paper';
import { useTranslation } from 'react-i18next';

import getGlobalStyles from '../globalStyles';
import { useThemeSettings } from '../ThemeProvider';
import SelectionOption from './SelectionOption';

import { useLanguageStore } from '../store/langStore';
import { LANGUAGES } from '../shared/constants/languages';

import { trackInteraction } from '../analytics/analyticsUtil';
import { ANALYTICS_EVENT, ACTION_TYPE } from '../analytics/types';

export default function LanguageModal() {
  const { appLang, setAppLang } = useLanguageStore();

  const { t } = useTranslation();
  const { theme} = useThemeSettings();
  const gStyles = useMemo(() => getGlobalStyles(theme), [theme]);

  const trackLanguageChange = (next: string, previous: string) => {
    trackInteraction({
      event: ANALYTICS_EVENT.INTERACTION,
      action: ACTION_TYPE.CLICK,
      screen_name: 'BOTTOM_MODAL',
      component: 'LanguageModal',

      context: {
        flow: "language",
        cta: "LANGUAGE_SWITCH",
        language_type: 'app',
        previous_locale: previous,
        selected_locale: next,
      },
    });
  };

  const onAppLangSelect = (val: string) => {
    const previousLocale = appLang;
    setAppLang(val);
    trackLanguageChange(val, previousLocale);
  };

  return (
    <>
      <Text style={[gStyles.subtitle, { maxWidth: 280 }]}>
        {t('screens.language.subtitle')}
      </Text>

      <Text style={gStyles.header2}>
        {t('screens.language.appLang')}
      </Text>

      {LANGUAGES.map((lang) => (
        <SelectionOption
          key={`app-${lang.value}`}
          label={lang.label}
          selected={appLang === lang.value}
          onPress={() => onAppLangSelect(lang.value)}
        />
      ))}
    </>
  );
}
